import { Button, Icons } from '@commenda/kakashi';
import {
  TWorkflowHelpResource,
  TWorkflowHelpResourceType,
} from '@commenda/types';

const defaultLabels: Record<TWorkflowHelpResourceType, string> = {
  video: 'Watch video',
};

const defaultIcons: Record<TWorkflowHelpResourceType, React.ReactNode> = {
  video: <Icons.PlayCircle className="w-4 h-4" />,
};

type WorkflowHelpResourceButtonsProps = {
  helpResources?: TWorkflowHelpResource[];
};

export const WorkflowHelpResourceButtons = ({
  helpResources,
}: WorkflowHelpResourceButtonsProps) => {
  if (!helpResources?.length) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {helpResources.map((resource) => (
        <Button
          key={resource.url}
          size="sm"
          variant="secondary"
          onClick={() =>
            window.open(resource.url, '_blank', 'noopener,noreferrer')
          }
        >
          {defaultIcons[resource.type]}
          {resource.label ?? defaultLabels[resource.type]}
        </Button>
      ))}
    </div>
  );
};
